import { DELETE_STEPPER_DATA, GLOBAL_STEPPER_DATA } from '../../../Redux/actions';

const intialState = {
  partner_profile: null,
  due_diligence_id: null,
  partner_panel_access_id: null,
  partner_share_login_credential_ids: null,
  work_info_id: null,
  ranking_id: null,
  review_id: null,
  questionnaire_id: null,
  partner_reference_ques_id: null,
  contractdocumentition_id: null,
  coaching_profile_field_id: null,
  Commision_info_admin_id: null,
  assessment_profile_id: null,
  associate_coaches_id: null,
  facilitation_profile_id: null,
  mentoring_profile_id: null,
  extraQuestion_id: null,
  quality_assurance_id: null,
  gdprs_id: null,
  facilitation_flag: false,
  mentoring_flag: false,
  assessor_flag: false,
  coach_flag: false,
  questionnaire_flag: false,
  general_profile_id: null,
  referenceDetail: [],
  updated_at: "",
  modified_by: "",
  created_at: "",
  created_by: "",
  last_assignment_date: "",
  no_of_assignment: "",
  next_available_date: "",
  currently_available_for_assignment:"",
  coaching_hr_id: []
};
const stepperReducer = (state = intialState, action) => {
    switch (action.type) {
        case GLOBAL_STEPPER_DATA:
            return Object.assign({}, state, action.payload);
        case DELETE_STEPPER_DATA:
            return intialState;
        default:
            return state;
    }
};
export default stepperReducer;
